export default __webpack_public_path__ + "./fonts/menu.d4e6eba2.svg";